import { render, staticRenderFns } from "./SalaryWidget.vue?vue&type=template&id=11c80667"
import script from "./SalaryWidget.vue?vue&type=script&lang=js"
export * from "./SalaryWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports